import { render, staticRenderFns } from "./OptionsTable.vue?vue&type=template&id=f48dcdb8"
import script from "./OptionsTable.vue?vue&type=script&lang=js"
export * from "./OptionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports